<template>
  <div>

    <v-layout row wrap mt-4>
      <v-flex xs12 sm3 text-xs-right class="hidden-xs-only">
        <image-app class="animated fadeInLeft" :imaSize="100" imaSrc="design/gray-arrow" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm4 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Administración del dinero" titleLevel="h1">
          <template slot="partOne">Administración<br></template>
          <template slot="partTwo">del </template>
          <template slot="partThree"> dinero</template>
        </ui-title-one>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Administración del dinero'" videoEmbed="ADMINISTRACIONDINERO02AdministracionDelDinero.mp4"></ui-simple-lsc>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm8 class="animated fadeInDown dura_2 adorn-bottom" mb-5>
        <p>Las personas reconocen la importancia de administrar el dinero, sin embargo la mayoría cree hacerlo bien 
          solo porque pagan sus cuentas a tiempo. Pero para administrar el dinero correctamente es necesario observar 
          cómo el panorama completo de los ingresos, gastos, patrimonio y deudas afecta las finanzas personales.
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-02.vue?6b77d5de